import { useParams } from '@tanstack/react-router';
import { lazy } from 'react';
import { GarageGate } from '../lib/gate.js';

const VehicleScreen = lazy(() => import('../screens/VehicleScreen.js'));

/** Fiche véhicule avec historique (espace garage). */
export default function VehiclePage() {
  const { vehicleId } = useParams({ strict: false });
  return <GarageGate>{vehicleId ? <VehicleScreen key={vehicleId} vehicleId={vehicleId} /> : null}</GarageGate>;
}
